<template>
  <td
    v-if="data.if !== false"
    :title="title"
    :colspan="colspan"
    :class="`${classItem} nowrap`">
      {{value}}
      <div v-if="data[column] && data[column].length && column === 0">
        <table class="table table-responsive-sm">
          <tr v-for="(valueRow, indexRow) in data" :key="`row-${indexRow}`">
            <td v-for="(valueColumn, indexColumn) in data[indexRow]" :class="colWidth ? 'w-'+colWidth[indexColumn] : ''" :key="valueColumn.value+indexColumn">
              {{ valueColumn.value }}
            </td>
            <td :class="colWidth ? 'w-'+colWidth[colWidth.length - 1] : ''" :key="`acoes${indexRow}${column}`">
              <slot :itemData="data[indexRow] || {}"></slot>
            </td>
          </tr>
        </table>
      </div>
  </td>
</template>

<script>
export default {
  props: {
    length: { required: true, type: Number },
    column: { required: true, type: Number },
    data: { required: true, type: Array },
    colWidth: { required: false, type: Array }
  },

  data () {
    return {
      title: '',
      type: '',
      colspan: '1',
      classItem: '',
      value: ''
    }
  },

  created () {
    this.title = this.data[this.column] && this.data[this.column].title ? this.data[this.column].title : ''
    this.type = this.data.type
    this.colspan = this.type ? `${this.length}` : '1'
    this.classItem = this.data[this.column] && this.data[this.column].class ? this.data[this.column].class : ''
    this.value = this.data[this.column] && !this.data[this.column].length ? this.data[this.column].value : ''
  }
}
</script>
